export const ADD_LEADS_NOTE_REQUEST = 'ADD_LEADS_NOTE_REQUEST';
export const ADD_LEADS_NOTE_REQUEST_SUCCESS = 'ADD_LEADS_NOTE_REQUEST_SUCCESS';
export const ADD_LEADS_NOTE_REQUEST_FAILURE = 'ADD_LEADS_NOTE_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/add_note.constants.js